// extracted by mini-css-extract-plugin
export default {"banner":"aboutus_banner__dpTle","bannerTxt":"aboutus_bannerTxt__c6Fw9","commonSection":"aboutus_commonSection__K11Ar"};